import React from "react";
import {
  Space,
  Row,
  Col,
  message,
  Image,
  Button,
  Modal,
  Tooltip,
  Drawer,
} from "antd";
import { observer } from "mobx-react";
import { StoreContext } from "../store/RootStore";
import { Link } from "react-router-dom";
import { CloseOutlined } from "@ant-design/icons";

import withRouter from "../withRouter";
import InspectionStore from "../store/InspectionStore";
import ListTable from "./ListTable";
import CompanyAutocomplete from "./CompanyAutocomplete";
import CompanyStore from "../store/CompanyStore";
import InspectionAdd from "./InspectionAdd";
import editIcon from "../assets/images/NewDesign/pencil-square.svg";
import refreshIcon from "../assets/images/NewDesign/refreshicon.svg";
class InspectionList extends React.Component {
  constructor(props, context) {
    super(props);

    this.handleTableChange = this.handleTableChange.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.onDelete = this.onDelete.bind(this);
    this.inspectionStore = new InspectionStore();
    this.companyStore = new CompanyStore();

    this.state = {
      loading: false,
      pageSize: 50,
      currentPage: 1,
      companyVal_Lab: "",
      openInspectionForm: false,
      inspectionId: "",
      listDataUpdate: false,
      openDeleteModal: false,
      deleteData: {},
      editData: {},
    };

    this.columns = [
      {
        // title: "Company",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_COMPANY_"),
        dataIndex: "company",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value, record) => {
          return (
            <Tooltip placement="topLeft" title={value}>
              <Link
                style={{ color: "#2563EB", textDecoration: "none" }}
                onClick={(e) => {
                  e.preventDefault();
                  this.onEdit(record);
                }}
              >
                {value}
              </Link>
            </Tooltip>
          );
        },
      },
      {
        // title: "Vehicle No",
        title: context.translate("_VEHICLE_NO_"),
        dataIndex: "vehicleNo",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Type",
        title: context.translate("_FLEET_DASHBORD_NEWPOI_TYPE_"),
        dataIndex: "types",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
        render: (value) => {
          console.log(value);
          if (value === "Array") {
            return;
          } else return <>{value}</>;
        },
      },
      {
        // title: "Technician Name",
        title: context.translate("_TECHNICIAN_NAME_"),
        dataIndex: "techname",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Comment",
        title: context.translate("_FLEET_CREATEROUTE_ROUTEADD_COMMENT_"),
        dataIndex: "comment",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Date",
        title: context.translate("_FLEET_REPORTS_DATE_"),
        dataIndex: "date",
        width: 15,
        ellipsis: {
          showTitle: true,
        },
      },
      {
        // title: "Action",
        title: context.translate("_ACTION_"),
        dataIndex: "groupname",
        ellipsis: {
          showTitle: true,
        },
        align: "center",
        width: 5,
        render: (_, record) => {
          return (
            <>
              <Space>
                <Tooltip
                  title={this.context.translate("_EDIT_")}
                  placement="bottom"
                >
                  <Image
                    style={{
                      height: "19px",
                      width: "14px",
                      borderRadius: "0px",
                      cursor: "pointer",
                    }}
                    src={editIcon}
                    onClick={async (e) => {
                      e.preventDefault();
                      await this.onEdit(record);
                    }}
                  ></Image>
                </Tooltip>
                <Tooltip
                  title={this.context.translate("_DELETE_")}
                  placement="bottom"
                >
                  <Image
                    src={require("../assets/images/NewDesign/Delete.png")}
                    style={{ cursor: "pointer", width: "14px" }}
                    onClick={() =>
                      this.setState({
                        openDeleteModal: true,
                        deleteData: record,
                      })
                    }
                  ></Image>
                </Tooltip>
              </Space>
            </>
          );
        },
      },
    ];
  }

  async componentDidMount() {
    if (
      Number(this.props.getUserData().isadmin) !== -1 &&
      Number(this.props.getUserData().isadmin) !== 3
    ) {
      await this.setState({
        companyId: this.props.getUserData().userCompanyId,
      });
      await this.setState({ userId: this.props.getUserData().userId });
      await this.handleSearch();
    }
    this.setState({ pageSize: 50 });
  }

  async componentDidUpdate(prevProps, prevState) {
    if (Number(this.props.getUserData().isadmin) === 0) {
      this.props.navigate("/login");
    }
    if (prevState.listDataUpdate !== this.state.listDataUpdate) {
      const setInspectionStates =
        this.context.viewStateStore.inspectionListObject;

      await this.inspectionStore.loadData({
        offset: (this.state.currentPage - 1) * this.state.pageSize,
        limit: this.state.pageSize,

        companyId: setInspectionStates.companyId,
      });
      const singleData = await this.companyStore.getCompanyDataById(
        setInspectionStates.companyId
      );

      await this.setState({ loadList: 1 });

      await this.setState({
        companyVal_Lab: singleData,
        companyId: setInspectionStates.companyId,
      });

      await this.setState({ listDataUpdate: false });
    }
  }
  async handleTableChange(pagination, filters, sorter) {
    await this.setState({
      currentPage: pagination.current,
      pageSize: pagination.pageSize,
    });
    await this.handleSearch();
  }
  async handleChange(comp) {
    await this.setState({
      companyId: comp.value,
      companyLoading: true,
      currentPage: 1,
      pageSize: 50,
    });
    const singleData = await this.companyStore.getCompanyDataById(comp.value);
    await this.setState({ companyVal_Lab: singleData });
    // await this.setState({ companyId: comp.value });
    await this.handleSearch();
  }

  async handleSearch() {
    await this.inspectionStore.loadData({
      offset: (this.state.currentPage - 1) * this.state.pageSize,
      limit: this.state.pageSize,
      // warehouseId:this.state.warehouseId,
      companyId: this.state.companyId,
    });
    await this.setState({ loadList: 1 });
  }

  onEdit = async (record) => {
    const inspectionId = record.ins_Id;
    if (inspectionId) {
      this.context.viewStateStore.setInspectionStates({
        companyId: record.companyId,
      });
      // this.props.navigate("/inspectionadd/" + inspectionId);
    }
    await this.setState({ inspectionId: record.ins_Id });
    await this.setState({ openInspectionForm: true });
  };

  onDelete = async (record) => {
    const response = await this.inspectionStore.deleteRecord({
      ins_Id: record.ins_Id,
      companyId: record.companyId,
    });

    if (response?.data?.success === "S") {
      message.success(response.data.message);
      this.setState({ openDeleteModal: false });
      this.handleSearch();
    } else {
      message.error(response.data.message);
    }
  };

  responseMsg = async (resp) => {
    if (resp.success == "S") {
      message.success(resp.message);
      await this.setState({ openInspectionForm: false });
      await this.setState({ listDataUpdate: true });

      //  await this.handleSearch();
      // this.props.navigate("/companyuserlist");
    } else {
      message.error(resp.message);
    }
  };

  closeModal = () => {
    this.setState({ openInspectionForm: false, inspectionId: "" });
  };

  refreshList = async () => {
    this.setState({ loading: true });
    await this.inspectionStore.loadData({
      offset: 0,
      limit: 50,
      companyId: this.state.companyId,
    });
    this.setState({ loading: false, currentPage: 1 });
  };
  render() {
    return (
      <>
        <div className="listHeader">
          <Row className="listInputRow">
            <Col span={16}>
              <Space>
                <CompanyAutocomplete
                  className="searchInput"
                  onChange={this.handleChange}
                  // allowClear={true}
                  style={{ width: 200 }}
                  value={
                    this.state.companyVal_Lab ? this.state.companyVal_Lab : null
                  }
                />
              </Space>
            </Col>
            <Col
              style={{
                display: "flex",
                alignItems: "center",
                justifyContent: "end",
              }}
              span={8}
            >
              <Tooltip
                title={this.context.translate("_REFRESH_")}
                placement="bottom"
              >
                <Image
                  style={{
                    height: 18,
                    marginInlineEnd: "20px",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                  src={refreshIcon}
                  onClick={() => this.refreshList()}
                ></Image>
              </Tooltip>

              <Button
                className="addButtonClass"
                onClick={() =>
                  this.setState({ openInspectionForm: true, inspectionId: "" })
                }
              >
                <Image
                  style={{ width: 13, marginInlineEnd: "5px" }} //marginInlineEnd: "5px",
                  src={require("../assets/images/NewDesign/plus (Stroke).png")}
                ></Image>
                {this.context.translate("_FLEET_DRIVER_DRIVERLIST_ADDBTN_")}
              </Button>
            </Col>
          </Row>

          <ListTable
            currentPage={this.state.currentPage}
            pageSize={this.state.pageSize}
            total={this.inspectionStore?.total}
            columns={this.columns}
            dataSource={this.inspectionStore?.inspection}
            loading={this.inspectionStore?.loading}
            onChange={this.handleTableChange}
          />

          {this.state.openInspectionForm && (
            <Drawer
              className="uploadExcelDrawer"
              width={716}
              closeIcon={false}
              open={this.state.openInspectionForm}
              placement={
                this.context.locale.language === "arabic" ? "left" : "right"
              }
              footer={false}
              title={
                <div className="formTitle">
                  {this.context.translate("_INSPECTION_DETAIL_")}
                  <p className="formDescription">
                    {this.context.translate("_INSPECTION_DESC_")}
                  </p>
                </div>
              }
              maskClosable={false}
              onOk={() => this.setState({ openInspectionForm: false })}
              onCancel={() =>
                this.setState({ openInspectionForm: false, inspectionId: "" })
              }
            >
              <div style={{ height: "100%" }}>
                <InspectionAdd
                  inspectionId={this.state.inspectionId}
                  response={this.responseMsg}
                  closeModal={this.closeModal}
                />
              </div>
            </Drawer>
          )}
        </div>
        {this.state.openDeleteModal && (
          <Modal
            maskClosable={false}
            title={
              <div className="deleteModalTitle">
                <span>
                  {" "}
                  {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
                </span>
                <CloseOutlined
                  style={{ cursor: "pointer", color: "white" }}
                  onClick={() => this.setState({ openDeleteModal: false })}
                />
              </div>
            }
            className="deleteModal"
            description="Are you sure you want to delete this Item? This action cannot be undone."
            centered
            open={this.state.openDeleteModal}
            footer={null}
            width={400}
            closable={false}
          >
            <div className="deleteModalText">
              <p>{this.context.translate("_DELETE_STATUS_")}</p>
            </div>
            <div className="deleteModalButtons">
              <Button
                className="deleteModalCancelButton"
                onClick={() => this.setState({ openDeleteModal: false })}
              >
                {this.context.translate("_FLEET_DASHBORD_SHOWPOI_CANCELBTN_")}
              </Button>

              <Button
                className="deleteModalOkButton"
                onClick={() => this.onDelete(this.state.deleteData)}
              >
                {this.context.translate("_FLEET_COMPANY_COMPANYLIST_DELETE_")}
              </Button>
            </div>
          </Modal>
        )}
      </>
    );
  }
}
InspectionList.contextType = StoreContext;
export default observer(withRouter(InspectionList));
